import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import React, { ComponentProps } from 'react'
import styled from 'styled-components'
import Group from 'components/utils/Group'

const Scroller = styled(HorizontalContainerWithFadedOverflow)`
  box-shadow: inset 0 -1px 0 ${props => props.theme.palette.neutral.default.five};
`

const Container = styled(Group)`
  > * {
    flex-shrink: 0;
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Describes how the tab children should be laid out
   * Grow will spread the tabs across the whole width of the group
   * Auto will make them only take up the room required per tab
   */
  fit?: 'auto' | 'grow'
  /**
   * @default fit
   */
  tabletFit?: 'auto' | 'grow'
  gap?: ComponentProps<typeof Group>['gap']
}

const TabButtonsGroup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    fit = 'auto',
    tabletFit,
    gap,
    ...restOfProps
  } = props

  return <Scroller
    {...restOfProps}
    ref={ref}
  >
    <Container
      direction="horizontal"
      horizontalAlign={fit === 'grow' ? 'stretch' : 'start'}
      tabletHorizontalAlign={(tabletFit ?? fit) === 'grow' ? 'stretch' : 'start'}
      gap={gap}
    >
      {children}
    </Container>
  </Scroller>
})

TabButtonsGroup.displayName = 'TabButtonsGroup'

export default TabButtonsGroup
